import React, { createContext, useState, useEffect } from 'react';

export const ProdutosContext = createContext();

export function ProdutosProvider({ children }) {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);

  const carregarProdutos = async () => {
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
    const tipo_usuario = localStorage.getItem("tipo_usuario");
    const estabelecimento_id = localStorage.getItem("estabelecimento_id");
    const id_universidade = localStorage.getItem("id_universidade");

    console.log('🔍 [PRODUTOS CONTEXT] Tipo de usuário:', tipo_usuario);
    console.log('🔍 [PRODUTOS CONTEXT] ID do estabelecimento:', estabelecimento_id);
    console.log('🔍 [PRODUTOS CONTEXT] ID da universidade:', id_universidade);

    try {
      let url;

      // Se for CLIENTE, buscar produtos do estabelecimento (restaurante avulso) ou da universidade
      if (tipo_usuario === "cliente") {
        const contextoUniversidade = localStorage.getItem("estabelecimento_contexto_universidade");
        const contextoEstabelecimentoId = localStorage.getItem("estabelecimento_contexto_id");
        const isRestauranteContext = contextoUniversidade === '' && !!contextoEstabelecimentoId;

        if (isRestauranteContext) {
          console.log('🍽️ [PRODUTOS CONTEXT] Cliente de restaurante - carregando produtos do estabelecimento:', contextoEstabelecimentoId);
          url = `${API_URL}/cadastroprodutos?id_estabelecimento=${contextoEstabelecimentoId}`;
        } else if (id_universidade) {
          console.log('👤 [PRODUTOS CONTEXT] Cliente detectado - carregando produtos da universidade:', id_universidade);
          url = `${API_URL}/cadastroprodutos?id_universidade=${id_universidade}`;
        } else {
          console.error('❌ [PRODUTOS CONTEXT] Cliente sem universidade nem estabelecimento de contexto!');
          setProdutos([]);
          setLoading(false);
          return;
        }
      } else {
        // Se for ADMIN ou GARÇOM, buscar produtos do estabelecimento específico.
        // Sem estabelecimento_id não dá pra saber qual loja é a dele — carregar
        // "todos os produtos" aqui misturaria produtos de outros estabelecimentos
        // no painel (furo de isolamento multi-tenant), então fica vazio até o
        // estabelecimento_id ser resolvido (ex: após o loginSuccess disparar de novo).
        if (!estabelecimento_id) {
          console.warn('⚠️ [PRODUTOS CONTEXT] ID do estabelecimento não encontrado - aguardando resolução antes de carregar produtos');
          setProdutos([]);
          setLoading(false);
          return;
        }
        console.log('🏪 [PRODUTOS CONTEXT] Admin/Garçom detectado - carregando produtos do estabelecimento:', estabelecimento_id);
        url = `${API_URL}/cadastroprodutos?id_estabelecimento=${estabelecimento_id}`;
      }

      const res = await fetch(url, { cache: 'no-store' });
      const data = await res.json();
      console.log('✅ [PRODUTOS CONTEXT] Produtos carregados:', data.length);
      setProdutos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('❌ [PRODUTOS CONTEXT] Erro ao carregar produtos:', error);
      setProdutos([]);
    } finally {
      setLoading(false);
    }
  };

  const carregarTodosProdutos = async () => {
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
    const id_universidade = localStorage.getItem("id_universidade");

    console.log('🔍 [PRODUTOS CONTEXT] Carregando TODOS os produtos da universidade:', id_universidade);

    let url = `${API_URL}/cadastroprodutos`;
    if (id_universidade) {
      url = `${API_URL}/cadastroprodutos?id_universidade=${id_universidade}`;
    }

    try {
      const res = await fetch(url, { cache: 'no-store' });
      const data = await res.json();
      console.log('✅ [PRODUTOS CONTEXT] Todos os produtos carregados:', data.length);
      setProdutos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('❌ [PRODUTOS CONTEXT] Erro ao carregar todos produtos:', error);
      setProdutos([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarProdutos(); // Carrega produtos do estabelecimento do usuário logado

    // 📢 Listener para recarregar produtos após login
    const handleLoginSuccess = () => {
      console.log('📢 [ProdutosContext] Evento loginSuccess recebido, recarregando produtos...');
      carregarProdutos();
    };

    window.addEventListener('loginSuccess', handleLoginSuccess);

    // Limpar listener ao desmontar
    return () => {
      window.removeEventListener('loginSuccess', handleLoginSuccess);
    };
  }, []);

  return (
    <ProdutosContext.Provider value={{ produtos, setProdutos, carregarProdutos, carregarTodosProdutos, loading }}>
      {children}
    </ProdutosContext.Provider>
  );
}
